
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const client = new ApolloClient({
  link: new HttpLink({
    uri: 'https://data.objkt.com/v3/graphql',
  }),
  cache: new InMemoryCache(),
});

export default client;
